import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faUsers } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import CommsFilterToggle from './CommsFilterToggle';

const CommunicationActivity = () => {
    const communicationActivity = useSelector(
        (state) => state.communication.communicationActivity,
        areCommsEqual
    );
    return (
        <div className="w-50 pr-2">
            <div className="w-100 p-3 sc-glass shadow sc-rounded">
                <div className="w-100">
                    <h2>Communication Activity</h2>
                    <CommsFilterToggle />
                </div>
                <div
                    className="w-100 px-2 py-2 border-top"
                    style={{
                        maxHeight: '500px',
                        minHeight: '500px',
                        overflowX: 'scroll',
                    }}>
                    {/* TODO: will this ever be big enough to virtualize? paginate? */}
                    {(communicationActivity || []).map((a, x) => (
                        <Link
                            key={a.communicationId}
                            className="w-100 p-0"
                            to={`/practices/${a.practiceId}/communications/${a.communicationId}`}
                            style={{
                                textDecoration: 'none',
                                color: 'white',
                            }}>
                            <div
                                className={classNames(
                                    'w-100 py-2 hoverable border-on-hover px-3 mb-3',
                                    {
                                        'bg-light-opacity-2': x % 2 === 0,
                                    }
                                )}>
                                <div className="w-100 d-flex justify-content-between flex-wrap">
                                    <div className="w-50 text-wrap pr-1">
                                        <h6>{a.practiceName}</h6>
                                    </div>
                                    <div className="w-50 text-wrap pl-1">
                                        <h6>{a.title}</h6>
                                    </div>
                                </div>
                                <div className="w-100 d-flex justify-content-between mt-2">
                                    <div className="w-50 op-7 d-flex justify-content-between pr-4">
                                        <span>
                                            <FontAwesomeIcon icon={faUsers} />
                                            &nbsp;
                                            {a.partnerName}
                                        </span>
                                        <span>
                                            <FontAwesomeIcon icon={faComment} />
                                            &nbsp;
                                            {a.commentCount}
                                        </span>
                                    </div>
                                    <div className="w-50 op-7">
                                        #{a.displayId}
                                        &emsp;Last active{' '}
                                        {moment
                                            .unix(a.lastActivity)
                                            .format('MMM D')}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                    <div className="text-center py-3 op-7">
                        That's all for communications
                    </div>
                </div>
            </div>
        </div>
    );
};

const areCommsEqual = (newCommsList, oldCommsList) => {
    if (newCommsList.length <= 0) return false;
    if (oldCommsList.length !== newCommsList.length) return false;
    if (!shallowEqual(newCommsList?.[0], oldCommsList?.[0])) return false;

    const commsEqualityCheck = (oldComm) => {
        const compareComms = (newComm) => {
            return shallowEqual(newComm, oldComm);
        };
        return newCommsList.some(compareComms);
    };

    const comparedCommList =
        !!oldCommsList.length && oldCommsList.every(commsEqualityCheck);

    const isSameCommList = !!newCommsList.length && comparedCommList;

    return isSameCommList;
};

export default CommunicationActivity;
